.layout {
  display: grid;
  grid-template-columns: 380px minmax(0, 1fr);
  gap: 1.15rem;
}

.card {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-lg, 16px);
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 4px 18px rgba(13, 28, 46, 0.05);
}

.cardTitle {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.98rem;
  font-weight: 800;
  color: #00236f;
  letter-spacing: -0.015em;
}

.cardSubtitle {
  font-size: 0.78rem;
  color: #444651;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.fieldGroup {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #444651;
}

.input,
.select {
  background: #f8f9ff;
  border: 1px solid #c5c5d3;
  border-radius: var(--radius-sm, 8px);
  padding: 0.58rem 0.75rem;
  font-size: 0.85rem;
  color: #0d1c2e;
  outline: none;
  font-variant-numeric: tabular-nums;
}

.input:focus,
.select:focus {
  background: #ffffff;
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.1);
}

.previewPill {
  padding: 0.65rem 0.8rem;
  border-radius: var(--radius-sm, 8px);
  background: #eff4ff;
  border: 1px solid #dce9ff;
  font-size: 0.76rem;
  color: #444651;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-variant-numeric: tabular-nums;
}

.submitBtn {
  padding: 0.68rem 1rem;
  border-radius: var(--radius-sm, 8px);
  border: none;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  font-weight: 700;
  font-size: 0.84rem;
  cursor: pointer;
  transition: opacity 0.15s ease;
  box-shadow: 0 4px 12px rgba(0, 35, 111, 0.2);
}

.submitBtn:hover {
  opacity: 0.94;
}

.ledgerList {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  max-height: 440px;
  overflow-y: auto;
}

.ledgerItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.9rem;
  padding: 0.8rem 0.95rem;
  border-radius: var(--radius-md, 12px);
  background: #f8f9ff;
  border: 1px solid #dce9ff;
}

.ledgerLeftWithThumb {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  min-width: 0;
  flex: 1;
}

.quickReceiptThumbBtn {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: 8px;
  padding: 0.18rem;
  cursor: pointer;
  flex-shrink: 0;
}

.quickReceiptThumbImg {
  width: 46px;
  height: 54px;
  object-fit: cover;
  border-radius: 5px;
  display: block;
}

.ledgerLeft {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}

.merchantRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
}

.merchantName {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.86rem;
  font-weight: 700;
  color: #0d1c2e;
}

.sourceBadge {
  font-family: var(--font-mono, monospace);
  font-size: 0.66rem;
  font-weight: 600;
  padding: 0.12rem 0.42rem;
  border-radius: 5px;
}

.sourceManual {
  background: #eff4ff;
  color: #444651;
  border: 1px solid #dce9ff;
}

.sourceOcr {
  background: #e6f7f5;
  color: #006a61;
  border: 1px solid #86f2e4;
}

.sourceApi {
  background: #eff4ff;
  color: #004469;
  border: 1px solid #cce5ff;
}

.ledgerMeta {
  font-size: 0.74rem;
  color: #444651;
}

.ledgerRight {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.15rem;
  font-variant-numeric: tabular-nums;
}

.expenseAmount {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.98rem;
  font-weight: 800;
  color: #0d1c2e;
  font-variant-numeric: tabular-nums;
}

.compressionTag {
  font-family: var(--font-mono, monospace);
  font-size: 0.72rem;
  color: #004469;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.quickActionsGroup {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.2rem;
}

.viewQuickReceiptBtn {
  padding: 0.2rem 0.5rem;
  border-radius: 5px;
  border: 1px solid #dce9ff;
  background: #eff4ff;
  color: #00236f;
  font-size: 0.68rem;
  font-weight: 700;
  cursor: pointer;
}

.deleteExpenseBtn {
  padding: 0.2rem 0.5rem;
  border-radius: 5px;
  border: 1px solid #ffdad6;
  background: #fff5f5;
  color: #ba1a1a;
  font-size: 0.68rem;
  font-weight: 600;
  cursor: pointer;
}

.quickModalBackdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(13, 28, 46, 0.55);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.quickModalDialog {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 14px;
  max-width: 580px;
  width: 100%;
  max-height: 90vh;
  overflow: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  box-shadow: 0 24px 64px rgba(13, 28, 46, 0.22);
}

.quickModalHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
}

.quickModalImg {
  width: 100%;
  max-height: 72vh;
  object-fit: contain;
  border-radius: 8px;
  background: #eff4ff;
  border: 1px solid #dce9ff;
}

@media (max-width: 980px) {
  .layout {
    grid-template-columns: 1fr;
  }
}
